/**
 * DIEUKYDIEU.TV - LIVE CHAT MODULE
 * Interactive support widget, automated smart responses, quick suggestions.
 */

import { state } from './state.js';
import { t } from './i18n.js';

export const LIVECHAT_SUGGESTIONS = [
    { key: 'livechat_sug_1', defaultText: 'Pháp Luân Đại Pháp là gì?' },
    { key: 'livechat_sug_2', defaultText: 'Hướng dẫn học 5 bài công pháp' },
    { key: 'livechat_sug_3', defaultText: 'Khỏi bệnh thần kỳ có thật không?' }
];

export function renderLiveChatSuggestions() {
    if (typeof document === 'undefined') return;
    const container = document.querySelector('#livechat-modal .chat-quick-suggestions');
    if (!container) return;
    container.innerHTML = LIVECHAT_SUGGESTIONS.map(item => {
        const text = t(item.key) || item.defaultText;
        const safeMsg = text.replace(/'/g, "\\'");
        return `<button class="chat-suggestion-chip" data-i18n="${item.key}" onclick="sendQuickChatMessage('${safeMsg}')">${text}</button>`;
    }).join('');
}

export function toggleLiveChat() {
    state.isLiveChatOpen = !state.isLiveChatOpen;
    const chatModal = document.getElementById('livechat-modal');
    const floatingBubble = document.getElementById('chat-floating-bubble');
    const sidebarChatBtn = document.getElementById('sidebar-nav-chat-btn');
    if (sidebarChatBtn) {
        sidebarChatBtn.classList.toggle('active', state.isLiveChatOpen);
        sidebarChatBtn.setAttribute('aria-selected', state.isLiveChatOpen ? 'true' : 'false');
    }
    if (chatModal) {
        chatModal.classList.toggle('show', state.isLiveChatOpen);
        if (state.isLiveChatOpen) {
            if (typeof window !== 'undefined' && typeof window.closeMobileSidebar === 'function') {
                window.closeMobileSidebar();
            }
            // Chỉ autofocus trên desktop/màn hình lớn (>= 768px) để tránh tự động bật bàn phím ảo che mất tin nhắn và gợi ý trên di động
            if (window.innerWidth >= 768) {
                setTimeout(() => {
                    const input = document.getElementById('livechat-input');
                    if (input) input.focus();
                }, 250);
            }
        }
    }
    if (floatingBubble) {
        floatingBubble.style.display = state.isLiveChatOpen ? 'none' : '';
    }
}

export function sendQuickChatMessage(msg) {
    const input = document.getElementById('livechat-input');
    if (input) {
        input.value = msg;
        sendUserChatMessage();
    }
}

export function sendUserChatMessage() {
    const input = document.getElementById('livechat-input');
    if (!input) return;
    const msgText = input.value.trim();
    if (!msgText) return;

    const msgBox = document.getElementById('livechat-messages');
    if (!msgBox) return;

    // Render User Bubble
    const userBubble = document.createElement('div');
    userBubble.className = 'chat-bubble user';
    userBubble.innerText = msgText;
    msgBox.appendChild(userBubble);
    input.value = '';
    msgBox.scrollTop = msgBox.scrollHeight;

    // Automated Intelligent Response
    setTimeout(() => {
        let reply = "Cảm ơn bạn đã chia sẻ cùng dieukydieu.tv! Chúng tôi đã ghi nhận câu hỏi của bạn và sẽ phản hồi chi tiết nhất. Bạn có thể xem thêm mục 'Dành cho người mới' trên trang Khám phá để hiểu rõ hơn nhé.";
        const lower = msgText.toLowerCase();

        if (lower.includes('pháp luân') || lower.includes('đại pháp') || lower.includes('là gì')) {
            reply = "Pháp Luân Đại Pháp (còn gọi là Pháp Luân Công) là môn khí công tu luyện cổ truyền của Phật gia theo nguyên lý Chân - Thiện - Nhẫn, gồm 5 bài tập nhẹ nhàng và các bài giảng tu tâm dưỡng tính.";
        } else if (lower.includes('công pháp') || lower.includes('học') || lower.includes('tập')) {
            reply = "Pháp Luân Công gồm 5 bài công pháp: Phật Triển Thiên Thủ Pháp, Pháp Luân Trang Pháp, Quán Thông Lưỡng Cực Pháp, Pháp Luân Chu Thiên Pháp và Thần Thông Gia Trì Pháp (thiền định). Toàn bộ tài liệu và video đều được phổ biến hoàn toàn miễn phí trên dieukydieu.tv.";
        } else if (lower.includes('bệnh') || lower.includes('thần kỳ') || lower.includes('khỏi')) {
            reply = "Rất nhiều người trên thế giới sau khi tu luyện Pháp Luân Đại Pháp đã chứng kiến sự phục hồi kỳ diệu cả về thể chất lẫn tinh thần nhờ tâm tính thăng hoa và năng lượng tích cực.";
        }

        const botBubble = document.createElement('div');
        botBubble.className = 'chat-bubble bot';
        botBubble.innerText = reply;
        msgBox.appendChild(botBubble);
        msgBox.scrollTop = msgBox.scrollHeight;
    }, 650);
}
